import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaseManagementService } from '../case-management.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { EnvironmentService } from '../../services/environment.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxLoadingModule } from 'ngx-loading';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-ad-hoc-modal',
  templateUrl: './ad-hoc-modal.component.html',
  styleUrls: ['./ad-hoc-modal.component.scss'],
  imports: [
    NgxLoadingModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class AdHocModalComponent implements OnInit {
  private cdRef = inject(ChangeDetectorRef);
  private dialogRef = inject<MatDialogRef<AdHocModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private cms = inject(CaseManagementService);
  private ss = inject(SessionStorageService);
  private snacky = inject(MatSnackBar);
  private envSvc = inject(EnvironmentService);

  repCode = null;
  repCodeValue = null;
  repCodeControl = new FormControl();
  caseTitle = new FormControl();

  assignedTo = null;
  caseStatus = null;
  caseStatusOptions = [];
  fileName;
  fileNameDisplay;
  file;
  fileType;
  caseDetails = {};
  message = '';
  messages = [];
  editMessageId = null;
  editMessage = '';
  selectedCaseFile = null;
  caseFiles = null;
  statusOptions = [];
  caseProfile = {};
  loading = false;
  caseUsers = [];
  isCaseManager = false;
  baseUrl: string;
  environment;
  caseNote = '';

  ngOnInit() {
    this.loading = true;
    const rights = this.ss.get('rights');
    this.isCaseManager = rights && rights.includes('CaseManager');
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
    this.getFilteredOptions();
    this.loading = false;
  }

  getFilteredOptions() {
    this.repCodeControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.getUserList(value);
        }
      });
  }

  getUserList(searchString?: string) {
    this.cms.getCmRepCodes(searchString).subscribe(resp => {
      const newUsersList = resp.names.map(user => ({
        value: user.repCode,
        display: user.name,
      }));
      this.caseUsers = newUsersList;
    });
  }

  setRepCode(ev) {
    const {
      option: { value },
    } = ev;
    this.repCode = value;
    this.repCodeValue = this.caseUsers.find(user => user.value === value).value;
  }

  createCase() {
    this.loading = true;
    const caseData = {
      CaseManagement: {
        Type: 'MANUAL',
        Title: this.caseTitle.value,
      },
      Client_Rep: {
        RepCode: [this.repCode],
      },
    };

    this.cms.createCaseManagementRecord(null, caseData).subscribe(resp => {
      if (resp) {
        setTimeout(() => {
          this.loading = false;
          this.snacky.open(`Case created!`, 'Close', {
            duration: 3000,
          });
          this.dialogRef.close({
            CRID: resp['result'],
          });
          this.cdRef.detectChanges();
        }, 2000);
      }
    });
  }

  handleKeyDown(ev) {
    if (ev.key === 'Enter' || ev.keyCode === 13) {
      this.close();
    }
  }

  close() {
    this.dialogRef.close({ data: 'cancel' });
  }
}
